export const LOW = 50;
export const HIGH = 75;
